// Gender-matched professional headshots, assigned deterministically by persona name
// so the same character shows the same face on the scenario card and the role-play screen.

const FEMALE_PHOTOS = [
  "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
  "https://images.unsplash.com/photo-1655249493799-9cee4fe983bb?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
  "https://images.unsplash.com/photo-1573497019707-1c04de26e58c?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
  "https://images.unsplash.com/photo-1665224752136-4dbe2dfc8195?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
  "https://images.unsplash.com/photo-1590650213165-c1fef80648c4?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
  "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
  "https://images.unsplash.com/photo-1590649880765-91b1956b8276?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
];

const MALE_PHOTOS = [
  "https://images.unsplash.com/photo-1659353220482-554773c2f7fa?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
  "https://images.unsplash.com/photo-1737574821698-862e77f044c1?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
  "https://images.unsplash.com/photo-1589386417686-0d34b5903d23?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
  "https://images.unsplash.com/photo-1584940120505-117038d90b05?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
  "https://images.unsplash.com/photo-1758518727984-17b37f2f0562?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
  "https://images.unsplash.com/photo-1780733058106-1126f2c42c0d?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
  "https://images.unsplash.com/photo-1737575655055-e3967cbefd03?crop=faces&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
];

const hashName = (name = "") =>
  name.split("").reduce((acc, c) => (acc * 31 + c.charCodeAt(0)) & 0xffffff, 0);

// Pick a gender-appropriate headshot deterministically from the persona name.
export const getPersonaPhoto = (name = "", gender = "") => {
  const g = String(gender || "").trim().toLowerCase();
  const pool = g.startsWith("f") ? FEMALE_PHOTOS : MALE_PHOTOS;
  return pool[hashName(name) % pool.length];
};
